/**
 * Created by
 * @author <yunishev@sotal.tv> Art Yunishev
 * on 18.07.2016.
 */

import React, {Component, PropTypes} from 'react';

import CommonMessage from './Common/common-message';
import AppsMessage from './Apps/apps-message';
import OffersMessage from './Offers/offers-message';
import PinMessage from './Pin/pin-message';
import PinChangeMessage from './PinChange/pin-change-message';
import NotificationMessage from './Notification/notification-message';
import ShareRequestMessage from './ShareRequest/share-request-message';
import BookmarkMessage from './Bookmark/bookmark-message';

class Message extends Component {

  _renderMessage() {

    switch (this.props.message.type) {
      case 'common':

        return <CommonMessage {...this.props} />;

      case 'apps':

        return <AppsMessage {...this.props} />;

      case 'offers':

        return <OffersMessage {...this.props} />;

      case 'pin':

        return <PinMessage {...this.props} />;

      case 'pin-change':

        return <PinChangeMessage {...this.props} />;

      case 'notification':

        return <NotificationMessage {...this.props} />;

      case 'share-request':

        return <ShareRequestMessage {...this.props} />;

      case 'bookmark':

        return <BookmarkMessage {...this.props} />;
    }
  }

  render() {

    return this._renderMessage();
  }
}

Message.propTypes = {
  message: PropTypes.shape({
    type: PropTypes.string.isRequired
  })
};

export default Message;



// WEBPACK FOOTER //
// ./src/components/ModalWindow/index.js